module.exports = __webpack_public_path__ + "img/error-posture.3827d507.svg";